import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ecosystem/deployment-tools/acquisition-app/components/AcqAppView.tsx");
